import { useLayoutEffect } from 'react';

/**
 * Marks the page as "booted": `<html data-motion="ready">`. Scroll-reveal primitives only hide their
 * content from this point on (see styles/motion.css), so server HTML, crawlers and visitors without
 * JavaScript always see everything. Set in a layout effect so the very first client paint already
 * has the hidden starting states — no flash of visible-then-hidden content.
 */
export function useMotionReady(): void {
  useLayoutEffect(() => {
    document.documentElement.dataset['motion'] = 'ready';
    return () => {
      delete document.documentElement.dataset['motion'];
    };
  }, []);
}
